import React, { useEffect, useState } from 'react';
import { dispatch, subscription, useReframe } from 'nike-re-framejs';
import moment from 'moment';
import Immutable from 'immutable';
import './DebugConsole.less';
import clsx from 'clsx';

function addLog(message, level) {
    return db =>
        db.updateIn(['uiconsole', 'logs'], (list = Immutable.List()) =>
            list.push(
                Immutable.Map({
                    time: new Date(),
                    message,
                    level
                })
            )
        );
}

export function logDebugConsole(message, level) {
    if (isDebugConsole()) {
        dispatch(addLog(message, level));
    }
}

const logs$ = subscription(db => db.getIn(['uiconsole', 'logs'], Immutable.List()));

export function DebugConsole() {
    const [show, setShow] = useState(true);
    const enabled = isDebugConsole();
    useEffect(() => {
        if (enabled) {
            logDebugConsole('Hi!');
        }
    }, [enabled]);
    if (!enabled) {
        return null;
    }
    return (
        <div className={clsx('debug-ui-console', { 'debug-ui-console-show': show })}>
            <ConsoleControl show={show} setShow={setShow} />
            {show ? <ConsoleLogs /> : null}
        </div>
    );
}

function ConsoleControl({ show, setShow }) {
    return (
        <div className="debug-ui-console-control" onClick={() => setShow(!show)}>
            {show ? 'hide console' : 'show console'}
        </div>
    );
}

function ConsoleLogs() {
    const derefSub = useReframe();
    const logs = derefSub(logs$);
    const rows = logs
        .map((log, i) => (
            <div key={i} className={clsx('row', 'row-' + log.get('level'))}>
                <small className={log.get('level')}>{moment(log.get('time')).format('HH:mm:ss.SSS')}</small>
                {log.get('message')}
            </div>
        ))
        .reverse()
        .slice(0, 120)
        .toArray();
    return <div className="debug-ui-console-logs">{rows}</div>;
}

let enabled = -1;

export function isDebugConsole() {
    if (enabled === -1) {
        enabled = !!window.localStorage.getItem('debug-ui-console');
    }
    return enabled;
}

export function showDebugConsole() {
    window.localStorage.setItem('debug-ui-console', JSON.stringify(true));
}

export function hideDebugConsole() {
    window.localStorage.removeItem('debug-ui-console');
}
